import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Dropdown", -1)

import { computed, getCurrentInstance, nextTick, ref, watch } from 'vue';
import { hasSpaceAtBottom } from '@/utils/dom';
import { useWindowResize } from '@/libraries/useWindowResize';
import { useWindowScroll } from '@/libraries/useWindowScroll';

// todo change custom select by element-plus and remove this events
interface Props {
  fullwidth?: boolean;
  show: boolean;
  top?: boolean;
  right?: boolean;
  indent?: number;
}


export default /*#__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'Dropdown',
  props: {
    fullwidth: { type: Boolean, default: false },
    show: { type: Boolean },
    top: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
    indent: { default: 5 }
  },
  emits: [
  'afterEnter',
  'afterLeave',
  'beforeEnter',
  'beforeLeave',
  'enter',
  'enterCancelled',
  'leave',
  'leaveCancelled',

  'click',
  'mouseout',
  'mousedown',
  'mouseup',
],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;



const $dropdown = ref<HTMLDivElement | null>(null);
const $content = ref<HTMLDivElement | null>(null);

const moveToTop = ref(false);
const controlRect = ref<DOMRect | undefined>(undefined);

const style = computed(() => {
  const contentRect = $content.value?.getBoundingClientRect();

  if (!controlRect.value || !contentRect) {
    return {};
  }

  const verticalAlignmentProps = moveToTop.value
    ? {
      bottom: `${window.innerHeight - controlRect.value.top + props.indent}px`,
    }
    : {
      top: `${controlRect.value.bottom + props.indent}px`,
    };

  return {
    width: props.fullwidth ? `${controlRect.value.width}px` : undefined,
    left: !props.right ? `${controlRect.value.x}px` : undefined,
    right: props.right ? `${window.innerWidth - controlRect.value.right}px` : undefined,
    ...verticalAlignmentProps,
  };
});

const currentInstance = getCurrentInstance();
const key = currentInstance?.vnode.key;

// todo change custom select by element-plus and remove this sheet
const transitionListeners = {
  'after-enter': (el: HTMLElement) => emit('afterEnter', el),
  'after-leave': (el: HTMLElement) => {
    emit('afterLeave', el);
    moveToTop.value = false;
  },
  'before-enter': (el: HTMLElement) => {
    emit('beforeEnter', el);

    nextTick(() => {
      moveToTop.value = props.top || !hasSpaceAtBottom(el);
    });
  },
  'before-leave': (el: HTMLElement) => emit('beforeLeave', el),
  enter: (el: HTMLElement) => emit('enter', el),
  'enter-cancelled': (el: HTMLElement) => emit('enterCancelled', el),
  leave: (el: HTMLElement) => emit('leave', el),
  'leave-cancelled': (el: HTMLElement) => emit('leaveCancelled', el),
};

const elementListeners = {
  click: (e: Event) => emit('click', e),
};

const updateControlRect = (): void => {
  controlRect.value = $dropdown.value?.getBoundingClientRect?.();
};

watch(
  () => props.show,
  () => updateControlRect(),
);

useWindowResize(updateControlRect, 100);
useWindowScroll(updateControlRect, 100);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "$dropdown",
    ref: $dropdown,
    class: "dropdown"
  }, [
    _renderSlot(_ctx.$slots, "trigger", {}, () => [
      _hoisted_1
    ]),
    _createVNode(_Transition, _mergeProps({
      name: "dropdown",
      appear: ""
    }, _toHandlers(transitionListeners)), {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", _mergeProps({
          ref_key: "$content",
          ref: $content
        }, _ctx.$attrs, {
          key: _unref(key),
          class: [`dropdown__content`, {
          [`dropdown_fullwidth`]: props.fullwidth,
          [`dropdown_top`]: moveToTop.value,
          'active': _ctx.show,
        }],
          style: style.value
        }, _toHandlers(elementListeners, true)), [
          _renderSlot(_ctx.$slots, "default")
        ], 16))
      ]),
      _: 3
    }, 16)
  ], 512))
}
}

})